import assetPath from '/app/packages/lebenslauf/articles/src/assets/meistere-deinen-jobwechsel-wie-du-d.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')